// extracted by mini-css-extract-plugin
export var active = "_2b-d";
export var blink = "_2b-e";
export var container = "_2b-5";
export var controls = "_2b-0";
export var controlsRight = "_2b-1";
export var fakeCursor = "_2b-c";
export var hidden = "_2b-b";
export var quillContainerSmall = "_2b-7";
export var quillEditor = "_2b-6";
export var quillEditorSmall = "_2b-8";
export var quillFormatButtons = "_2b-a";
export var quillToolbar = "_2b-9";
export var removePadding = "_2b-2";
export var state = "_2b-3";
export var stateTitle = "_2b-4";